export class Registrar {

    public Id: string;
    public Rut: string;
    public Passaporte: string;
    public Nacionalidad: string;
    public Nombre: string;
    public Nombre2: string;
    public ApellidoP: string;
    public ApellidoM: string;
    public Correo: string;
    public Telefono: string;
    public Genero: string;
    public Clave: string;
    public Clave2: string;
    public Aceptaterminos: boolean;
    
    public constructor(item: any) {
        this.Id=item.Id;
        this.Rut=item.RUT;
        this.Passaporte=item.Passaporte;
        this.Nacionalidad=item.Nacionalidad;
        this.Nombre=item.Nombre;
        this.Nombre2=item.Nombre2;
        this.ApellidoP=item.ApellidoP;
        this.ApellidoM=item.ApellidoM;
        this.Correo=item.Correo;
        this.Telefono=item.Telefono;
        this.Genero=item.Genero;
        this.Clave=item.Clave;
        this.Clave2=item.Clave2;
        this.Aceptaterminos = item.Aceptaterminos;
    }
}
